import { h } from "preact";
import { useEffect } from "preact/hooks";
import axios from "axios";

const PRODUCTLANE_WIDGET_KEY = process.env.REACT_APP_PRODUCTLANE_WIDGET_KEY;
const PRODUCTLANE_WIDGET_SCRIPT = "https://widget.productlane.com/latest.productlane-widget.min.js";

function initProductlane() {
    ((w) => {
        const P = (w.Productlane = { queue: {} });
        ["set", "open", "close", "toggle", "on", "off", "init", "signOut"].forEach((m) => {
            P[m] = ((n) => function () { P.queue[n] = { args: arguments }; })(m);
        });
    })(window);
}

function loadWidgetScript() {
    const script = document.createElement("script");
    script.src = PRODUCTLANE_WIDGET_SCRIPT;
    script.async = true;
    script.defer = true;
    script.crossOrigin = "anonymous";
    document.body.appendChild(script);
}

export default function ProductlaneWidget() {
    useEffect(() => {
        initProductlane();

        axios.get("/support-portal/widget-token")
            .then(({ data }) => {
                window.Productlane.init({
                    widgetKey: PRODUCTLANE_WIDGET_KEY,
                    userToken: data.token,
                    position: "left",
                });
            })
            .catch(() => {
                window.Productlane.init({
                    widgetKey: PRODUCTLANE_WIDGET_KEY,
                    position: "left",
                });
            })
            .finally(() => {
                loadWidgetScript();
            });
    }, []);

    return null;
}
